import React from 'react';
import MagicForm from '../../../../../../Components/Form/MagicForm';
import { ItemScheme } from '../../../../../../Components/Form/MagicFormItem';
import { MagicField } from '../../../../../../Enums/MagicField.enum';
import {
	UpdateGroupInput,
	useGroupQuery,
} from '../../../../../../graphql/graphql';
import Loading from '../../../../../../Components/Loading';

interface Props {
	groupId: string;
	onSubmit: (values: UpdateGroupInput) => void;
}

const EArchiveGroupSettingsActionsUpdateForm = ({
	groupId,
	onSubmit,
}: Props) => {
	const { data, isLoading } = useGroupQuery({ id: groupId });

	const formScheme: ItemScheme[] = [
		{
			type: MagicField.TEXT_FIELD,
			key: 'name',
			title: 'component.eArchive.group.settings.formGroupName',
			settings: { required: true },
		},
	];

	if (isLoading) {
		return <Loading />;
	}

	const defaultValues = {
		name: data?.group?.name || '',
	};

	return (
		<MagicForm
			formScheme={formScheme}
			defaultValues={defaultValues}
			onSubmit={onSubmit}
			submitText={'base.shared.form.send'}
		/>
	);
};

export default EArchiveGroupSettingsActionsUpdateForm;
